import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'gl-schedule-route-stops-page',
    templateUrl: './schedule-route-stops-page.component.html',
    styleUrls: ['./schedule-route-stops-page.component.scss']
})
export class ScheduleRouteStopsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    routeId = null;
    directionId = null;
    constructor(private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.routeId = params['routeId'];
            this.directionId = params['directionId'];
        });
    }
}
